import { STATES } from '../../../constants';

export const GetStartedInfoConfig = $stateProvider => {
  'ngInject';
  $stateProvider.state(STATES.GET_STARTED_1, {
    url: '/1',
    disableBreadcrumb: true,
    scrollTop: true,
    analytics: {
      page: 'Get Started: Name and Move Date',
      success: 'Saved Name and Move Date',
    },
    views: {
      'form@app.get-started': {
        template: '<upd-get-started-info></upd-get-started-info>',
      },
    },
    data: {
      header: `That was easy, let's keep going!`,
      subHeader:
        'We just need a bit more information about your move so we can provide a great Updater experience.',
      next: STATES.GET_STARTED_2,
      stepIndicatorIndex: 0,
    },
  });
};
